import { PageListDataSource } from './BaseDataSources';
import { IPackageVersion } from '../Interfaces';

export class DealVersionSource extends PageListDataSource<IPackageVersion> {
  public constructor(dealId: string) {
    super('/datasource/dealversions', { dealId });
  }
}